var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarHalf = function SvgStarHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "-293 385 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-271 394.2-7.2-.6-2.8-6.6-2.8 6.6-7.2.6 5.5 4.7-1.6 7 6.2-3.7 6.2 3.7-1.6-7zm-10 6.2v-9.3l1.7 4 4.4.4-3.3 2.9 1 4.3z"
  })));
};
export default SvgStarHalf;